import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=40b1cf8e&scoped=true"
import script from "./shop.js?vue&type=script&lang=js&external"
export * from "./shop.js?vue&type=script&lang=js&external"
import style0 from "./shop.scss?vue&type=style&index=0&id=40b1cf8e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b1cf8e",
  null
  
)

export default component.exports